import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import theme from 'react/shared/theme/Theme';
import PALETTE from 'react/shared/theme/palette';
import { currencyFormatter } from 'react/shared/utils/Money';

const getSxStyles = () => ({
  header: {
    backgroundColor: PALETTE.grey,
  },
  headerInner: {
    width: '940px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '30px 0px',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      width: '90vw',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '20px',
    },
  },
  balanceBoxContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: {
      xs: '10px',
      sm: '40px',
    },
  },
});

const mockAllCardholders = [
  { slug: '1', nickname: 'Cardholder 1', cardholder_name: 'John Doe' },
  { slug: '2', nickname: 'Cardholder 2', cardholder_name: 'Jane Doe' },
];

const mockWalletTotal = 3300;
const mockCardTotal = 150.55;
const mockFirstName = 'John';

export default function ClientViewHeader({ personId }) {
  const sxStyles = getSxStyles();

  const currentDashboard = mockAllCardholders?.find((a) => a.slug == personId);

  const [value, setValue] = useState(currentDashboard);
  const [inputValue, setInputValue] = useState('');

  const onChange = (_e, value) => {
    setValue(value);
    if (value.slug) window.location.href = `/member/dashboard/${value.slug}`;
  };

  const breadcrumbs = [
    <Link color={PALETTE.blue} href={RailsRoutes.accounts_list_path()} key="1" underline="hover">
      All clients
    </Link>,
    <Link color={PALETTE.blue} key="2" underline="always">
      Client view
    </Link>,
  ];

  const allCardAccountsSelect = (
    <Autocomplete
      disableClearable
      getOptionLabel={(option) =>
        option.nickname ? `${option.cardholder_name} (${option.nickname})` : option.cardholder_name
      }
      id="select_account"
      inputValue={inputValue}
      onChange={onChange}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      options={mockAllCardholders || []}
      renderInput={(params) => <TextField {...params} label="Cardholders" variant="outlined" />}
      renderOption={(props, option) => (
        <li {...props} key={option.slug}>
          {option.nickname
            ? `${option.cardholder_name} (${option.nickname})`
            : option.cardholder_name}
        </li>
      )}
      size={'small'}
      sx={{ width: { xs: '100%', sm: '250px' } }}
      value={value}
    />
  );

  const balanceBox = (label, balance, textAlign) => (
    <Box sx={{ minWidth: '100px', textAlign: { xs: textAlign, sm: 'right' } }}>
      <Typography sx={{ mb: '5px', opacity: '50%', whiteSpace: 'nowrap' }} variant="caption">
        {label}
      </Typography>{' '}
      <Typography sx={{ fontWeight: 400, fontSize: { xs: '22px', sm: '26px' } }}>
        {currencyFormatter(balance)}
      </Typography>
    </Box>
  );

  return (
    <div className="client-view-header">
      <Box sx={sxStyles.header}>
        <Box sx={sxStyles.headerInner}>
          {mockAllCardholders.length > 1 && (
            <Box sx={{ width: '100%' }}>
              <Breadcrumbs aria-label="breadcrumb" color={PALETTE.blue} separator="<">
                {breadcrumbs}
              </Breadcrumbs>
              <Box sx={{ mt: 2, mr: 2 }}>{allCardAccountsSelect}</Box>
            </Box>
          )}
          <Box sx={sxStyles.balanceBoxContainer}>
            {balanceBox(`${mockFirstName}'s Wallet`, mockWalletTotal, 'left')}
            {balanceBox('True Link Card', mockCardTotal, 'left')}
            <Divider flexItem orientation="vertical" sx={{ borderColor: PALETTE.grey4 }} />
            {balanceBox('Total Funds', mockWalletTotal + mockCardTotal, 'right')}
          </Box>
        </Box>
      </Box>
    </div>
  );
}

ClientViewHeader.propTypes = {
  personId: PropTypes.string.isRequired,
};
